import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

export const unissueManufactureOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/manufacture-orders/:id/unissue',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/manufacture-orders/:id/unissue' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

export const unissueManufactureOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 5,
        "number": "1006",
        "revisionNumber": 4,
        "note": "",
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "dateCreated": "2021-04-10T18:09:26.823-0600",
        "lastModified": {
            "username": "admin",
            "dateLastModified": "2021-05-21T15:59:24.519-0600"
        },
        "dateScheduled": "2021-04-10T18:09:26.705-0600",
        "url": "",
        "percentComplete": "0%",
        "status": "Entered",
        "class": {
            "id": 1,
            "name": "None"
        },
        "configurations": [
            {
                "id": 53,
                "bom": {
                    "id": 7,
                    "name": "BK100"
                },
                "priceAdjustment": "0",
                "unitCost": "0",
                "dateScheduled": "2021-04-10T18:09:26.000-0600",
                "dateScheduledToStart": "2021-04-10T18:09:26.000-0600",
                "sortId": 1,
                "stageLevel": 1,
                "hasSo": false,
                "status": "Entered",
                "quantity": "15",
                "quantityFulfilled": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "priority": "3-Normal",
                "items": [
                    {
                        "id": 54,
                        "stage": false,
                        "priceAdjustment": "0",
                        "unitCost": "0",
                        "sortId": 1,
                        "part": {
                            "id": 80,
                            "name": "BK100",
                            "description": "New to Biking Kit"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "oneTimeItem": false,
                        "status": "Entered",
                        "quantity": "15",
                        "quantityFulfilled": "0",
                        "type": "Finished Good"
                    },
                    {
                        "id": 55,
                        "stage": false,
                        "priceAdjustment": "0",
                        "unitCost": "0",
                        "sortId": 2,
                        "part": {
                            "id": 52,
                            "name": "PM100",
                            "description": "Entry Bike Pump"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "oneTimeItem": false,
                        "status": "Entered",
                        "quantity": "15",
                        "quantityFulfilled": "0",
                        "type": "Raw Good"
                    },
                    {
                        "id": 56,
                        "stage": false,
                        "priceAdjustment": "0",
                        "unitCost": "0",
                        "sortId": 3,
                        "part": {
                            "id": 77,
                            "name": "H100",
                            "description": "Basic Bike Helmet"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "oneTimeItem": false,
                        "status": "Entered",
                        "quantity": "15",
                        "quantityFulfilled": "0",
                        "type": "Raw Good"
                    },
                    {
                        "id": 57,
                        "stage": false,
                        "priceAdjustment": "0",
                        "unitCost": "0",
                        "sortId": 4,
                        "part": {
                            "id": 56,
                            "name": "PK100",
                            "description": "Patch Kit"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "oneTimeItem": false,
                        "status": "Entered",
                        "quantity": "15",
                        "quantityFulfilled": "0",
                        "type": "Raw Good"
                    }
                ]
            }
        ],
        "customFields": [
            {
                "id": 25,
                "name": "Custom",
                "type": "Text"
            },
            {
                "id": 29,
                "name": "Type",
                "type": "Drop-Down List"
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'unissue-manufacture-order',
    title: 'Unissue a manufacture order',
    description: 'Unissues the manufacture order with the specified ID.',
    endpoint: {
        verb: 'POST',
        path: '/manufacture-orders/:id/unissue',
        tooltip: 'Unissue a manufacture order',
    },
    attributes: [],
    requestObject: unissueManufactureOrderRequest,
    responseObject: unissueManufactureOrdersResponse,
};

export default data;
